import React from 'react';
import { observer } from 'mobx-react-lite';
import { ContactInfo } from 'types/groupService';
import { createStyles } from './styles';

interface GeneralContactInfoProps {
  contactInfo: ContactInfo;
  groupName: string;
  carrierGroupNumber?: string;
}

const GeneralContactInfo: React.FC<GeneralContactInfoProps> = observer(
  ({ contactInfo, groupName, carrierGroupNumber }) => {
    const classes = createStyles();

    return (
      <div className={classes.contentWrapper}>
        <h1 className={classes.groupName} id="group-name">
          {groupName}
        </h1>
        {carrierGroupNumber && (
          <div className={classes.contactFieldBox}>
            <p className={classes.fieldName}>Group Number:</p>
            <p className={classes.fieldValue}>{carrierGroupNumber}</p>
          </div>
        )}
        <div className={classes.contactFieldBox}>
          <p className={classes.fieldName}>Contact Name:</p>
          <p className={classes.fieldValue}>
            {contactInfo.firstName} {contactInfo.lastName}
          </p>
        </div>
        <div className={classes.contactFieldBox}>
          <p className={classes.fieldName}>Title:</p>
          <p className={classes.fieldValue}>{contactInfo.title}</p>
        </div>
        <div className={classes.contactFieldBox}>
          <p className={classes.fieldName}>Address:</p>
          <p className={classes.fieldValue}>
            {contactInfo.primaryAddress && (
              <>
                {contactInfo.primaryAddress.street && `${contactInfo.primaryAddress.street}, `}
                {contactInfo.primaryAddress.street2 && `${contactInfo.primaryAddress.street2}, `}
                {contactInfo.primaryAddress.city && `${contactInfo.primaryAddress.city}, `}
                {contactInfo.primaryAddress.state} {contactInfo.primaryAddress.zip}
              </>
            )}
          </p>
        </div>
        <div className={classes.contactFieldBox}>
          <p className={classes.fieldName}>Contact Phone Number:</p>
          <p className={classes.fieldValue}>{contactInfo.primaryPhone}</p>
        </div>
        <div className={classes.contactFieldBox}>
          <p className={classes.fieldName}>Contact Email address:</p>
          <p className={classes.fieldValue}>{contactInfo.primaryEmail}</p>
        </div>
      </div>
    );
  },
);

export default GeneralContactInfo;
